import { request } from "../libs";

export default (serverUrl, id) => {
	return request(
		`${serverUrl}/phone-menu/${id}`,
		{
			method: "GET"
		}
	)
		.then(response => response.json());
};
